import { defineStore } from 'pinia'

import type { TutorBillingStore } from './interfaces'

import { TUTOR_BILLING_DEFAULT_PER_PAGE } from '@config/tutor-billing'
import { emptyTutorBillingFilters } from '@helpers/tutor-billing-query'

import { actions } from './actions'
import { getters } from './getters'

export const useTutorBillingStore = defineStore('tutor-billing', {
  state: (): TutorBillingStore => ({
    loading: false,
    saving: false,
    rows: [],
    meta: null,
    filters: emptyTutorBillingFilters(),
    currentPage: 1,
    perPage: TUTOR_BILLING_DEFAULT_PER_PAGE,
    selectedIds: [],
    modal: null,
    activeRow: null,
    exportType: null,
    returnPath: null,
  }),
  actions,
  getters,
})
